export default class {
  constructor() {
    this.id = 0;
    this.priceDutyFreeDayOne = 0;
    this.priceDutyFreeDayTwo = 0;
    this.priceDutyFreeDayThree = 0;
    this.priceDutyFreeDayFour = 0;
    this.priceDutyFreeDayFive = 0;
    this.priceDutyFreeDaySix = 0;
    this.priceDutyFreeDaySeven = 0;
    this.priceDutyFreeDayEight = 0;
    this.priceDutyFreeDayNine = 0;
    this.priceDutyFreeDayTen = 0;
    this.priceDutyFreeDayEleven = 0;
    this.priceDutyFreeDayTwelve = 0;
    this.priceDutyFreeDayThirteen = 0;
    this.priceDutyFreeDayFourteen = 0;
  }

  hydrate(data) {
    if (void 0 !== data.id) this.id = data.id;
    if (void 0 !== data.priceDutyFreeDayOne) this.priceDutyFreeDayOne = Number(data.priceDutyFreeDayOne);
    if (void 0 !== data.priceDutyFreeDayTwo) this.priceDutyFreeDayTwo = Number(data.priceDutyFreeDayTwo);
    if (void 0 !== data.priceDutyFreeDayThree) this.priceDutyFreeDayThree = Number(data.priceDutyFreeDayThree);
    if (void 0 !== data.priceDutyFreeDayFour) this.priceDutyFreeDayFour = Number(data.priceDutyFreeDayFour);
    if (void 0 !== data.priceDutyFreeDayFive) this.priceDutyFreeDayFive = Number(data.priceDutyFreeDayFive);
    if (void 0 !== data.priceDutyFreeDaySix) this.priceDutyFreeDaySix = Number(data.priceDutyFreeDaySix);
    if (void 0 !== data.priceDutyFreeDaySeven) this.priceDutyFreeDaySeven = Number(data.priceDutyFreeDaySeven);
    if (void 0 !== data.priceDutyFreeDayEight) this.priceDutyFreeDayEight = Number(data.priceDutyFreeDayEight);
    if (void 0 !== data.priceDutyFreeDayNine) this.priceDutyFreeDayNine = Number(data.priceDutyFreeDayNine);
    if (void 0 !== data.priceDutyFreeDayTen) this.priceDutyFreeDayTen = Number(data.priceDutyFreeDayTen);
    if (void 0 !== data.priceDutyFreeDayEleven) this.priceDutyFreeDayEleven = Number(data.priceDutyFreeDayEleven);
    if (void 0 !== data.priceDutyFreeDayTwelve) this.priceDutyFreeDayTwelve = Number(data.priceDutyFreeDayTwelve);
    if (void 0 !== data.priceDutyFreeDayThirteen) this.priceDutyFreeDayThirteen = Number(data.priceDutyFreeDayThirteen);
    if (void 0 !== data.priceDutyFreeDayFourteen) this.priceDutyFreeDayFourteen = Number(data.priceDutyFreeDayFourteen);
  }
}
